import { FrontendRateSchedule } from 'components/views/forms/rates/RateSchedule/types';

export type MinimalRateSchedule = Pick<FrontendRateSchedule, 'MIN_NIGHTS' | 'BASE_RATE' | 'ID'>;

export enum StoreNames {
  alluraEvent = 'alluraEvent',
  dashboard = 'dashboard',
  management = 'management',
  onboarding = 'onboarding',
  fullCalendar = 'fullCalendar',
  propertyId = 'propertyId',
  calendarRate = 'calendarRate',
  calendarEditRate = 'calendarEditRate',
  userId = 'userId',
}
